import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-body text-center p-3" }
const _hoisted_3 = { class: "datepicker-container" }
const _hoisted_4 = {
  key: 1,
  class: "modal-backdrop fade show"
}

import { ref, watch } from "vue";
import VueDatePicker from "@vuepic/vue-datepicker";

const locale = "de";
const format = "dd.MM.yyyy";

// Initialize when component becomes visible

export default {
  __name: 'CalendarDatePicker',
  props: {
	isVisible: {
		type: Boolean,
		default: false,
	},
	currentDate: {
		type: Date,
		default: () => new Date(),
	},
},
  emits: ["close", "dateSelected"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Date picker state
const selectedDate = ref(null);
const datePicker = ref(null);

// Date picker configuration
watch(
	() => props.isVisible,
	(isVisible) => {
		if (isVisible) {
			selectedDate.value = new Date(props.currentDate);
		}
	}
);

// Modal event handlers
function handleBackdropClick(event) {
	// Only close if clicking the modal itself (backdrop), not the modal-dialog
	if (event.target === event.currentTarget) {
		closePicker();
	}
}

// Date selection handler
function handleDateSelect(date) {
	if (date) {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		const dateString = `${year}-${month}-${day}`;

		emit("dateSelected", dateString);
		closePicker();
	}
}

function closePicker() {
	emit("close");
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Bootstrap Modal "),
    (__props.isVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "calendar-date-picker-modal modal fade show d-block",
          tabindex: "-1",
          onClick: handleBackdropClick
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "modal-content",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createCommentVNode(" Modal Header "),
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "modal-title" }, [
                  _createElementVNode("i", { class: "fas fa-calendar-alt me-2" }),
                  _createTextVNode(" Zu Datum springen ")
                ], -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closePicker
                })
              ]),
              _createCommentVNode(" Modal Body "),
              _createElementVNode("div", _hoisted_2, [
                _createCommentVNode(" Vue Datepicker "),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(VueDatePicker), {
                    ref_key: "datePicker",
                    ref: datePicker,
                    modelValue: selectedDate.value,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = $event => ((selectedDate).value = $event)),
                      handleDateSelect
                    ],
                    locale: locale,
                    format: format,
                    "enable-time-picker": false,
                    inline: "",
                    "auto-apply": "",
                    "month-change-on-scroll": false,
                    class: "vue-datepicker"
                  }, null, 8 /* PROPS */, ["modelValue"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Modal Backdrop "),
    (__props.isVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}